import { ANSWER_VALUES, SOURCE_VALUES } from "types/imageQueries";

export const YES_LABEL = "PASS";
export const NO_LABEL = "FAIL";
export const UNSURE_LABEL = "__UNSURE";
export const NEEDS_REVIEW_LABEL = "NEEDS_REVIEW";
export const DROPPED_LABEL = "__DROPPED";
export const NOT_YET_REVIEWED_LABEL = "__NOT_YET_REVIEWED";
export const DEFAULT_CONFIDENCE = 0.5;
export const OTHER_LABEL = "Other";
export const GREATER_THAN_MAX = "GREATER_THAN_MAX";
export const BOUNDING_BOX = "BOUNDING_BOX";
export const NO_OBJECTS = "NO_OBJECTS";
export const NO_TEXT_LABEL = "";

export interface LabelMapping {
  renderedLabel: string;
  backendLabel: string;
  bannerClassName?: string;
  className?: string;
  hoverColor?: string;
  baseColor?: string;
  textColor?: string;
  borderColor?: string;
  baseClass?: string;
  renderButton?: boolean;
}

export interface ColumnMapping {
  datagridLabel: string;
  backendLabel: string;
}

export const labelMap: Map<string, string> = new Map([
  [YES_LABEL, "Yes"],
  [NO_LABEL, "No"],
  [UNSURE_LABEL, "Unclear"],
  [NEEDS_REVIEW_LABEL, "Needs Review"],
]);

// TODO: Deprecated
export const labelMappings: LabelMapping[] = [
  {
    backendLabel: YES_LABEL,
    bannerClassName: "bg-opacity-20 bg-purple-300 border border-purple-300",
    baseClass:
      "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded shadow-xl",
    baseColor: "bg-purple-400",
    borderColor: "border-purple-500",
    hoverColor: "transition ease-in-out duration-200 hover:bg-purple-600 shadow-xl",
    renderButton: true,
    renderedLabel: "Yes",
    textColor: "text-purple-700",
  },
  {
    backendLabel: NO_LABEL,
    bannerClassName: "bg-opacity-20 bg-pink-300 border border-pink-300",
    baseClass:
      "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded shadow-xl",
    baseColor: "bg-pink-400",
    borderColor: "border-pink-500",
    hoverColor: "transition ease-in-out duration-200 hover:bg-pink-600 shadow-xl",
    renderButton: true,
    renderedLabel: "No",
    textColor: "text-pink-700",
  },
  {
    backendLabel: UNSURE_LABEL,
    bannerClassName: "bg-opacity-20 bg-zinc-300 border border-zinc-300",
    baseClass:
      "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded shadow-xl",
    baseColor: "bg-zinc-400",
    borderColor: "border-zinc-500",
    hoverColor: "transition ease-in-out duration-200 hover:bg-zinc-600 shadow-xl",
    renderButton: true,
    renderedLabel: "Unclear",
    textColor: "text-zinc-700",
  },
  {
    backendLabel: NEEDS_REVIEW_LABEL,
    baseClass:
      "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded shadow-xl",
    baseColor: "bg-slate-400",
    borderColor: "border-slate-500",
    hoverColor: "transition ease-in-out duration-200 hover:bg-slate-600 shadow-xl",
    renderButton: false,
    renderedLabel: "Unclear",
    textColor: "text-slate-700",
  },
  {
    backendLabel: DROPPED_LABEL,
    baseClass: "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded",
    baseColor: "bg-gray-400",
    borderColor: "border-gray-500",
    hoverColor: "bg-gray-500",
    renderButton: false,
    renderedLabel: "Dropped",
    textColor: "text-gray-700",
  },
  {
    backendLabel: NOT_YET_REVIEWED_LABEL,
    bannerClassName: "bg-opacity-20 bg-white border border-white-300",
    baseClass: "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded",
    baseColor: "bg-white",
    borderColor: "border-white-300",
    hoverColor: "bg-opacity-50",
    renderButton: false,
    renderedLabel: "Not Yet Reviewed",
    textColor: "text-white-700",
  },
];

export const inReviewQueueMappings: LabelMapping[] = [
  { renderedLabel: "false", backendLabel: "0" },
  { renderedLabel: "true", backendLabel: "1" },
];

export const sourceMappingsIQ: LabelMapping[] = [
  { renderedLabel: "Algorithm", backendLabel: SOURCE_VALUES.ALGORITHM },
  { renderedLabel: "Customer", backendLabel: SOURCE_VALUES.HUMAN_CUSTOMER },
  { renderedLabel: "Algorithm Unclear", backendLabel: SOURCE_VALUES.ALGORITHM_UNCLEAR },
  { renderedLabel: "Algorithm Reconciled", backendLabel: SOURCE_VALUES.ALGORITHM_RECONCILED },
  { renderedLabel: "Cloud Labeler", backendLabel: SOURCE_VALUES.HUMAN_CLOUD },
  { renderedLabel: "Cloud Ensemble", backendLabel: SOURCE_VALUES.HUMAN_CLOUD_ENSEMBLE },
];

const unsureStyles = {
  bannerClassName: "bg-opacity-20 bg-zinc-300 border border-zinc-300",
  baseClass:
    "text-white-400 font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded shadow-xl",
  baseColor: "bg-zinc-400",
  borderColor: "border-transparent",
  hoverColor: "transition ease-in-out duration-200 hover:bg-zinc-600 shadow-xl",
  renderButton: false,
  textColor: "text-white",
};

export const labelMappingsIQ: LabelMapping[] = [
  {
    renderedLabel: "Unclear",
    backendLabel: ANSWER_VALUES.UNCLEAR,
    bannerClassName: "bg-opacity-20 bg-zinc-300 border border-zinc-300",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#919599]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#FFFFFF]",
  },
  {
    renderedLabel: "Yes",
    backendLabel: ANSWER_VALUES.YES,
    bannerClassName: "bg-[#6151da]",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#6151da]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#6151da]",
  },
  {
    renderedLabel: "No",
    backendLabel: ANSWER_VALUES.NO,
    bannerClassName: "bg-[#A02BDF]",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#A02BDF]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#A02BDF]",
  },
  {
    renderedLabel: OTHER_LABEL,
    backendLabel: OTHER_LABEL,
    bannerClassName: "bg-opacity-20 bg-[#0450BA] border border-primary",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#0450BA]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#FFFFFF]",
  },
  {
    renderedLabel: "Greater than max",
    backendLabel: GREATER_THAN_MAX,
    bannerClassName: "bg-opacity-20 bg-[#529fe8] border border-primary",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#529fe8]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#FFFFFF]",
  },
  {
    renderedLabel: "Bounding boxes",
    backendLabel: BOUNDING_BOX,
    bannerClassName: "bg-opacity-20 bg-[#529fe8] border border-primary",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#529fe8]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#FFFFFF]",
  },
  {
    renderedLabel: "No objects",
    backendLabel: NO_OBJECTS,
    bannerClassName: "bg-opacity-20 bg-[#0450BA] border border-primary",
    baseClass: "text-white font-semibold shadow-xl",
    baseColor: "bg-[#0450BA]",
    borderColor: "border-transparent",
    hoverColor: "transition ease-in-out duration-200 shadow-xl",
    renderButton: true,
    textColor: "text-[#FFFFFF]",
  },
  // eslint-disable-next-line
  { renderedLabel: "Unclear", backendLabel: ANSWER_VALUES.__UNSURE, ...unsureStyles },
  { renderedLabel: "Unclear", backendLabel: ANSWER_VALUES.UNSURE, ...unsureStyles },
  { renderedLabel: "Needs review", backendLabel: ANSWER_VALUES.NEEDS_REVIEW, ...unsureStyles },
];

export function labelInternalToUI(mappings: LabelMapping[], internalLabel?: string | null, suffix?: string) {
  if (internalLabel === "") {
    return "----";
  }
  if (!internalLabel) {
    return "";
  }

  const requestedMapping = mappings.find((labelMapping) => labelMapping.backendLabel === internalLabel);
  // Returns input if internalLabel is not found in labelMappings
  const mappedLabel = requestedMapping ? requestedMapping.renderedLabel : internalLabel;
  return `${mappedLabel}${suffix ? ` ${suffix}` : ""}`;
}

export const dataPageColumnMappings: ColumnMapping[] = [
  // TODO: is this up to date?
  { datagridLabel: "predictor_name", backendLabel: "predictor__name" },
  { datagridLabel: "in_review_queue", backendLabel: "review_requested_priority" },
  { datagridLabel: "date", backendLabel: "created_at" },
  { datagridLabel: "prompt", backendLabel: "predictor__label_prompt" },
  { datagridLabel: "predictor_id", backendLabel: "predictor__id" },
  { datagridLabel: "posicheck_id", backendLabel: "id" },
  { datagridLabel: "created_by", backendLabel: "owner__name" },
];

export function columnUIToInternal(UILabel: string) {
  const requestedMapping = dataPageColumnMappings.find((columnMapping) => columnMapping.datagridLabel === UILabel);
  // Returns input if internalLabel is not found in columnMappings
  return requestedMapping ? requestedMapping.backendLabel : UILabel;
}

const dataGridColumns = {
  Image: "image",
  Override: "override",
  Answer: "answer",
  Source: "source",
  "Original Prediction": "original_prediction",
  "Original Confidence": "original_confidence",
  "In Review Queue": "in_review_queue",
  Timestamp: "timestamp",
  Predictor: "predictor_name",
  Prompt: "prompt",
  "Predictor ID": "predictor_id",
  "Posicheck ID": "posicheck_id",
};

// mapping from datagrid column headerName to field
export function getColumnField(headerName: string): string {
  return headerName in dataGridColumns ? dataGridColumns[headerName as keyof typeof dataGridColumns] : headerName;
}

export const metricsColumns = [
  labelInternalToUI(labelMappings, YES_LABEL),
  labelInternalToUI(labelMappings, NO_LABEL),
  `${labelInternalToUI(labelMappings, UNSURE_LABEL)}`,
  "Total",
];
